import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSettingList } from './slices/setting';
import Root from './Common/Root';

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_APP_ENV === 'PROD') {
      // Disable Right Click
      const handleContextMenu = e => e.preventDefault();
      // Disable Copy
      const handleCopy = e => e.preventDefault();
      // Disable Paste
      const handlePaste = e => e.preventDefault();
      // Disable Cut
      const handleCut = e => e.preventDefault();

      const handleKeyDown = e => {
        // F12
        if (e.keyCode === 123) {
          e.preventDefault();
        }
        // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
        if (
          (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
          (e.ctrlKey && e.key === 'U')
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('copy', handleCopy);
      document.addEventListener('paste', handlePaste);
      document.addEventListener('cut', handleCut);
      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        document.removeEventListener('copy', handleCopy);
        document.removeEventListener('paste', handlePaste);
        document.removeEventListener('cut', handleCut);
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, []);

  const dispatch = useDispatch();
  const { isLoggedIn, user } = useSelector(state => state.auth);
  const settingStatus = useSelector(state => state.setting.status);
  
  useEffect(() => {
    if (!isLoggedIn || !user) return;

    if (settingStatus === 'idle') {
      dispatch(fetchSettingList());
    }
  }, [isLoggedIn, user, settingStatus, dispatch]);

  // if (isLoggedIn && (settingStatus === 'idle' || settingStatus === 'loading')) {
  //   return <div>Loading system settings...</div>;
  // }

  return (
    <div className="App">
      <BrowserRouter
        future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
      >
        <Root />
      </BrowserRouter>
    </div>
  );
}

export default App;
